import React, { useState } from "react";

import { CheckboxField, SubmissionForm } from "@bps/fluent-ui";
import { ValidationSchema, Validator } from "@bps/validator";
import { BulkActionResponse } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useAssignDeploymentRingBulkAction } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { SelectDeploymentRingFieldItem } from "../../../common/SelectDeploymentRingFieldItem";
import {
  BulkActionType,
  BulkAssignDeploymentRingFormValues
} from "../../formTypes";
import { BulkActionFormWrapper } from "../BulkActionFormWrapper";

const validator = new Validator<BulkAssignDeploymentRingFormValues>();

const schema: ValidationSchema<BulkAssignDeploymentRingFormValues> = {
  selectorId: validator.string().required({ message: "Selector is required" }),
  actionType: validator
    .string()
    .required({ message: "Action Type is required" }),
  deploymentRingId: validator
    .string()
    .required({ message: "Deployment ring is required" })
};

export const AssignDeploymentRingForm: React.FC = () => {
  const [responseMessage, setResponseMessage] = useState<
    BulkActionResponse | undefined
  >();

  const {
    mutateAsync: assignDeploymentRingAction
  } = useAssignDeploymentRingBulkAction();

  const onSubmit = async (formValues: BulkAssignDeploymentRingFormValues) => {
    const { selectorId, deploymentRingId, assignHighestPriority } = formValues;
    if (assignHighestPriority === undefined || !deploymentRingId || !selectorId)
      return;

    // Submit request for bulk action
    const response = await assignDeploymentRingAction({
      assignHighestPriority,
      deploymentRingId,
      selectorId
    });

    setResponseMessage(response);
  };

  return (
    <SubmissionForm<BulkAssignDeploymentRingFormValues>
      onSubmit={onSubmit}
      initialValues={{
        actionType: BulkActionType.AssignDeploymentRing,
        deploymentRingId: undefined,
        selectorId: undefined,
        assignHighestPriority: false
      }}
      validate={values => validator.validate(values, schema)}
      hideButtons
    >
      {(state, actions) => {
        // Required to register deploymentRingId field since it does not exist af field control
        !state.fields["deploymentRingId"] &&
          actions.registerField("deploymentRingId");

        return (
          <BulkActionFormWrapper responseMessage={responseMessage}>
            <CheckboxField
              label="Assign as highest priority"
              name="assignHighestPriority"
            />
            <SelectDeploymentRingFieldItem fieldName="deploymentRingId" />
          </BulkActionFormWrapper>
        );
      }}
    </SubmissionForm>
  );
};
